import { motion } from "framer-motion";

type CookieBannerProps = {
  onAcceptAll: () => void;
  onOpenSettings: () => void;
};

const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

const CookieBanner: React.FC<CookieBannerProps> = ({
  onAcceptAll,
  onOpenSettings,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      transition={{
        duration: 3,
        delay: 20,
        ease: EASE_OUT,
      }}
      className="fixed bottom-6 left-6 z-[103] max-w-sm rounded-xl bg-white p-4 shadow-lg border left-[max(1.5rem,calc((100vw-1440px)/2+1.5rem))]"
    >
      <p className="text-sm text-gray-600">
        We use cookies to enhance your experience and analyze site traffic.
      </p>

      <div className="mt-3 flex gap-3">
        <button
          onClick={onAcceptAll}
          className="rounded-md bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
        >
          Accept All
        </button>

        <button
          onClick={onOpenSettings}
          className="rounded-md bg-gray-100 px-4 py-2 text-sm hover:bg-gray-200"
        >
          Cookie Settings
        </button>
      </div>
    </motion.div>
  );
};

export default CookieBanner;
